import logo from './Icons/logo.png'
import logo_scrolled from './Icons/logo_scrolled.png'
import rotaShow from './Icons/rotaShow.svg'
import waves from './Icons/waves.svg'
import comma from './Icons/comma.svg'
import dots from './Icons/dots.svg'
import dots_2 from './Icons/dots_2.svg'

import about_award_1 from './Icons/about_award_1.svg'
import about_award_2 from './Icons/about_award_2.svg'
import about_design_1 from './Icons/about_design_1.svg'
import about_design_2 from './Icons/about_design_2.svg'

import home_sec1 from './images/home_sec1.png'
import home_sec3_1 from './images/home_sec3_1.png'
import home_sec3_2 from './images/home_sec3_2.png'
import home_sec4 from './images/home_sec4.png'
import home_sec4_2 from './images/home_sec4_2.png'
import home_sec5 from './images/home_sec5.jpg'

import user1 from './images/users/user1.jpg'
import user2 from './images/users/user2.jpg'
import user3 from './images/users/user3.jpg'
import user4 from './images/users/user4.jpg'
import user5 from './images/users/user5.jpg'

import ball from './images/integrations/ball.png'
import color_ball from './images/integrations/color_ball.png'
import dimond from './images/integrations/dimond.png'
import drive from './images/integrations/drive.png'
import figma from './images/integrations/figma.png'
import fish from './images/integrations/fish.png'
import line from './images/integrations/line.png'
import google from './images/integrations/google.png'
import music from './images/integrations/music.png'
import snap from './images/integrations/snap.png'
import stair from './images/integrations/stair.png'
import vs from './images/integrations/vs.png'

import about_sec1 from './images/about_sec1.jpg'
import about_sec1_2 from './images/about_sec1_2.jpg'
import about_sec1_3 from './images/about_sec1_3.jpg'
import about_sec3 from './images/about_sec3.jpg'
import about_loc_1 from './images/about_loc_1.jpg'
import about_loc_2 from './images/about_loc_2.jpg'
import about_loc_3 from './images/about_loc_3.jpg'
import about_loc_4 from './images/about_loc_4.jpg'

import team_1 from './images/users/team/team_1.jpg'
import team_2 from './images/users/team/team_2.jpg'
import team_3 from './images/users/team/team_3.jpg'
import team_4 from './images/users/team/team_4.jpg'
import team_5 from './images/users/team/team_5.jpg'
import team_6 from './images/users/team/team_6.jpg'
import team_7 from './images/users/team/team_7.jpg'
import team_8 from './images/users/team/team_8.jpg'

 const resources = {
    icons: {
        logo,
        logo_scrolled,
        rotaShow,
        waves,
        comma,
        dots,
        dots_2,
        about_award_1,
        about_award_2,
        about_design_1,
        about_design_2,
    },
    images:{
        home_sec1,
        home_sec3_1,
        home_sec3_2,
        home_sec4,
        home_sec4_2,
        home_sec5,
        about_sec1,
        about_sec1_2,
        about_sec1_3,
        about_sec3,
        about_loc_1,
        about_loc_2,
        about_loc_3,
        about_loc_4,
        users: {
            user1,
            user2,
            user3,
            user4,
            user5,
        },
        integration: {
            ball,
            color_ball,
            dimond,
            drive,
            figma,
            fish,
            google,
            line,
            music,
            snap,
            stair,
            vs
        },
        team : {
            team_1,
            team_2,
            team_3,
            team_4,
            team_5,
            team_6,
            team_7,
            team_8,
        }
    }
 }

 export default resources ;